// FunPoint SDK wrapper service

/**
 * Check if FunPoint SDK is loaded and available
 * @returns {boolean} True if SDK is loaded
 */
export const isSDKLoaded = () => (typeof window !== 'undefined' && typeof window.funpoint !== 'undefined');

/**
 * Wrapper function to safely access FunPoint SDK with error handling
 * @param {function} operation Function that uses the SDK
 * @param {function} [errorCallback] Optional callback for error handling
 * @returns {any} Result of the operation or null if SDK access failed
 */
const withSDK = (operation, errorCallback) => {
  if (!window.jQuery) {
    const error = 'jQuery not loaded - required by FunPoint SDK';

    console.error(error);

    if (errorCallback) { errorCallback(error); }

    return null;
  }

  if (!isSDKLoaded()) {
    const error = 'FunPoint SDK not loaded';

    console.error(error);
    if (errorCallback) { errorCallback(error); }

    return null;
  }

  try {
    return operation(window.funpoint);
  } catch (error) {
    console.log('FunPoint SDK operation failed:', errorCallback, error);

    if (errorCallback) { errorCallback(error); }

    return null;
  }
};

/**
 * Initialise FunPoint SDK with merchant configuration
 * @param {function} callback: Callback function for initialisation result.
 */
export const initializeSDK = (callback) => {
  /**
   * Initialize FunPoint SDK
   * @param {string} ServerType: Required. Stage (test) or Prod (production)
   * @param {function} Callback: Callback function for initialisation result. Send errMsg if failed
   */
  withSDK(
    // (sdk) => sdk.initialize('Stage', callback),
    (sdk) => sdk.initialize('Prod', callback),
    (error) => callback(error)
  );
};

/**
 * Get credit card payment form
 * @param {string} token: Required. Payment method
 * @param {function} callback: Required. Return URL
 */
export const getCreditCardForm = (token, callback) => {
  /**
   * Get credit card payment form
   * @param {string} Token: Required. Payment method
   * @param {string} Language: Required. Language: { zhTW: "zh-TW", enUS: "en-US" }
   * @param {function} Callback: Required. Return URL
   */
  return withSDK(
    (sdk) => sdk.getAddBindingCardUIInfo(token, sdk.Language.zhTW, callback),
    (error) => callback(error)
  );
};

/**
 * Get payment token
 * @param {object} formData Payment form data
 * @returns {Promise<Object|null>} Payment form object or null if creation fails
 */
export const getPaymentToken = (callback) => {
  return withSDK(
    (sdk) => sdk.getBindingCardPayToken(callback),
    (error) => callback(error)
  );
};
